module.exports = __webpack_public_path__ + "img/yjyj.ed0f1f5d.png";